"use client"

import React, {useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {useMediaQuery} from "@mantine/hooks";


const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize, lang } = useGlobalStateStore();
    const [tab, setTab] = useState<number>(1);
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');


    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name_c="聯絡我們" name_e="Contact Us"/>
                    )
                }
                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        {lang == "tw" ? "聯絡我們" : "Contact Us"}
                    </div>


                    <div className="flex gap-[30px]">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.269839247782!2d121.53978071500616!3d25.024915083976595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442aa29379b8db9%3A0xd64e16f1fa2db70b!2zMTA25Y-w5YyX5biC5aSn5a6J5Y2A5ZKM5bmz5p2x6Lev5LqM5q61MTA26Jmf!5e0!3m2!1szh-TW!2stw!4v1600426140878!5m2!1szh-TW!2stw"
                            aria-hidden="false" className="w-full rounded-[15px] h-[400px]"></iframe>
                    </div>


                    <div className="pt-[30px] flex flex-col gap-[45px]">
                        <div className="flex flex-col gap-[10px]">
                            <div className="text-[30px] font-bold"> {lang == "tw" ? "中心地址" : "Address"}</div>
                            <div className="text-[20px] text-[#8d7f4c] font-bold ps-[25px] border-l border-[#ccc]">
                                {lang == "tw" ? "10636 台北市大安區和平東路二段106號1, 14-15樓" : "1, 14-15F, No. 106 , Heping E. Rd. , Sec. 2 , Taipei 10636, Taiwan (R.O.C.)"}
                            </div>
                        </div>
                        <div className="flex flex-col gap-[10px]">
                            {lang == "tw" && (
                                <div className="text-[30px] font-bold">一般諮詢與研發成果運用之利益衝突通報信箱</div>)}

                            <div
                                className="text-[20px] text-[#8d7f4c] font-bold ps-[25px] border-l border-[#ccc] leading-10">


                                {lang == "tw" && (<>02-2737-7657<br/>pr.stpi@niar.org.tw</>)}
                                {lang == "en" && (<>Tel：+886-2-2737-7657<br/>Fax：+886-2-2737-7448</>)}
                            </div>
                        </div>
                        <div className="flex flex-col gap-[10px]">
                            <div
                                className="text-[30px] font-bold">{lang == "tw" ? "文通方式" : "Traffic Information"}</div>
                            <div className="text-[20px] font-bold ps-[25px] border-l border-[#ccc] leading-10">
                                <div className="text-[#8d7f4c]">{lang == "tw" ? "搭乘捷運" : "By MRT:"}</div>
                                <div
                                    className="text-black">{lang == "tw" ? "搭乘至「文湖線科技大樓站」" : "Wenhu Line- Technology Building Station"}</div>
                                {
                                    lang == "tw" && (
                                        <div
                                            className="text-black font-normal">可於台北火車站搭乘捷運，請先搭乘板南線往南港方向，再於忠孝復興站轉文湖線，往動物園方向，於科技大樓站下車。
                                        </div>
                                    )
                                }
                            </div>

                            <div className="text-[20px] font-bold ps-[25px] border-l border-[#ccc] leading-10 mt-10">
                                <div className="text-[#8d7f4c]">{lang == "tw" ? "搭乘公車" : "By Bus:"}</div>
                                <div
                                    className="text-black">{lang == "tw" ? "最接近之公車站牌為「復興南路口」" : "Fuxing South Road Stop"}</div>
                                <div
                                    className="text-black font-normal">
                                    {lang == "tw" && "科技大樓位於和平東路與復興南路口，可搭乘公車：3, 15, 18, 52, 72, 74, 207, 211, 235, 237, 278, 284, 295, 662, 663, 680, 和平幹線, 敦化幹線。"}
                                    {lang == "en" && "Bus: 3, 15, 18, 52, 72, 74, 207, 211, 235, 237, 278, 284, 295, 662, 663"}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
        ;
}
